var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbStakeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_316_2332)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02604 15.9844L9.03721 20.0787L12.5161 22.1259V24.5229L7.00124 21.2884V14.7872L9.02604 15.9844ZM9.02604 11.8902V14.276L7 13.0775V10.6917L9.02604 9.49316L11.062 10.6917L9.02604 11.8902ZM13.9689 10.6917L15.995 9.49316L18.031 10.6917L15.995 11.8902L13.9689 10.6917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4902 19.2301V16.8331L12.5163 18.0316V20.4174L10.4902 19.2301ZM13.9691 22.9844L15.9952 24.1829L18.0311 22.9844V25.3703L15.9952 26.5688L13.9691 25.3703V22.9844ZM20.9368 10.6917L22.9629 9.49316L24.9988 10.6917V13.0775L22.9629 14.276V11.8902L20.9368 10.6917ZM22.9629 20.0787L22.974 15.9844L25.0001 14.7859V21.2872L19.4852 24.5216V22.1246L22.9629 20.0787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5094 19.229L19.4834 20.4164V18.0305L21.5094 16.832V19.229Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.51 12.7391L21.5212 15.1361L18.0324 17.1832V21.2874L16.0063 22.4747L13.9803 21.2874V17.1832L10.4915 15.1361V12.7391L12.5262 11.5406L15.9939 13.5976L19.4827 11.5406L21.5187 12.7391H21.51ZM10.4902 8.64603L15.9952 5.40039L21.51 8.64603L19.484 9.84454L15.9952 7.78748L12.5163 9.84454L10.4902 8.64603Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_2332",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD632"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbStakeActive);
export default __webpack_public_path__ + "static/media/bnbStakeActive.0abf7d44f172b3b4f553187b633283a7.svg";
export { ForwardRef as ReactComponent };